import { Divider, DividerProps, styled } from '@mui/material';
import { ReactElement } from 'react';

const StyledDivider = styled(Divider)(() => ({
    alignSelf: 'center',
    height: '1.15em',
    minHeight: '1em',
    borderColor: 'currentColor',
    borderRightWidth: '1px',
    opacity: 0.5,
}));

export const VerticalDivider = (props: DividerProps): ReactElement => {
    return <StyledDivider orientation="vertical" flexItem={true} {...props} />;
};
